<template>
  <div
    class="animated-number"
    ref="refRoot"
  >
    <div class="spacer">{{ value }}</div>
    <div
      class="animated"
      ref="refAnimated"
      :aria-hidden="true"
    >
      {{ 0 }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  value: {
    required: true,
  },
  duration: {
    default: 1,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)
const refAnimated = ref(null)

useScrollTrigger(() => {
  const tl = $gsap.timeline({
    scrollTrigger: {
      trigger: refRoot.value,
      start: "top bottom",
      end: "top center",
      toggleActions: "play none none reset",
      // scrub: true,
      // markers: true,
    },
  })

  tl.add("start")

  tl.fromTo(
    refAnimated.value,
    { textContent: 0 },
    {
      textContent: () => {
        return props.value
      },
      snap: { textContent: 1 },
      ease: "power1.out",
      duration: props.duration,
      modifiers: {
        textContent: function (innerText) {
          return $gsap.utils
            .snap(1, innerText)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
      },
    },
    "start"
  )

  return tl
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.animated-number {
  position: relative;
}

.spacer {
  opacity: 0;
}

.animated {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
